import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import VerifyEmail from "@/pages/VerifyEmail";
import ThankYou from "@/pages/ThankYou";
import SetPassword from "@/pages/SetPassword";
import Dashboard from "@/pages/Dashboard";
import Portfolio from "@/pages/Portfolio";
import SeoAudit from "@/pages/SeoAudit";
import RankTracking from "@/pages/RankTracking";
import Competitors from "@/pages/Competitors";
import LinkBuilding from "@/pages/LinkBuilding";
import ContentStudio from "@/pages/ContentStudio";
import LocalSeo from "@/pages/LocalSeo";
import Conversion from "@/pages/Conversion";
import Settings from "@/pages/Settings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/seo-audit" element={<SeoAudit />} />
              <Route path="/rank-tracking" element={<RankTracking />} />
              <Route path="/competitors" element={<Competitors />} />
              <Route path="/link-building" element={<LinkBuilding />} />
              <Route path="/content" element={<ContentStudio />} />
              <Route path="/local-seo" element={<LocalSeo />} />
              <Route path="/conversion" element={<Conversion />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
